<template>
  <a-button
    class="approval-btn-void"
    v-if="IsShwoOffPayMent && typebtn == 'primary'"
    :loading="loading"
    :disabled="false"
    @click="offPayment"
    >{{ btnName }}</a-button
  >
  <a
    v-if="typebtn == 'text'"
    href="javascript:void(0);"
    :loading="loading"
    type="link"
    @click="offPayment"
    class="theme-color"
    :style="btnName == '取消申请' ? { color: '#2F7BFF' } : { color: '#ff4d4f' }"
  >
    {{ btnName }}
  </a>
</template>
  <script lang="ts">
import { Modal, message } from "ant-design-vue";
import { getCurrentUserId } from "@/utils";
import { updateStatusOffPayment } from "./fund-off-payment.service";
import { defineComponent, computed, reactive, ref, toRefs, watch } from "vue";
import uploadFileTable from "@/biz-components/upload-file-table/index.vue";
export default defineComponent({

  name: "FundOffPayment",
  isGlobal: true,
  props: {
    bizType: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    basicInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 按钮类型
    typebtn: {
      type: String,
      default: "primary",
    },
    // 按钮名称
    btnName: {
      type: String,
      default: "取消申请",
    },
    // 取消申请ID
    offPaymentId: {
      type: String,
      required: true,
    },
    // 业务状态字段名
    updateStatus:{
      type: String,
      default: "costPaymentStatus",
    },
    // 后台要改的业务状态
    status: {
      type: String,
      default: "qxfk",
    }
  },
  emits: ["refresh", "update:loading"],
  components: { uploadFileTable },
  setup(props, { emit }) {
    // 取消申请按钮显隐
    const IsShwoOffPayMent = computed(() => {
      return (
        props.basicInfo.createBy === state.currentUserId &&
        (props.basicInfo.flowStatus === "spbtg" && props.basicInfo[props.updateStatus] === 'ywlcz')
      );
    });
    const state = reactive({
      currentUserId: getCurrentUserId(),
    });
    const getPropsOffPaymentId = ref();
    getPropsOffPaymentId.value = props.offPaymentId;
    const { status, bizType,offPaymentId } = props;
    const updateStatusOffPaymentData = reactive({
      status,
      bizId: offPaymentId,
      bizType
    });

    const { run } = updateStatusOffPayment();
    // 取消申请
    const offPayment = async () => {
      try {
        emit("update:loading", true);
        const res = await run(updateStatusOffPaymentData);
        if (res.respCode !== "0000") {
          message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        emit("refresh",null);
      } finally {
        emit("update:loading", false);
      }
    };

    return {
      IsShwoOffPayMent,
      ...toRefs(state),
      offPayment,
    };
  },
});
</script>